import { render, staticRenderFns } from "./detail-payin.vue?vue&type=template&id=494af536&scoped=true"
import script from "./detail-payin.vue?vue&type=script&lang=js"
export * from "./detail-payin.vue?vue&type=script&lang=js"
import style0 from "./detail-payin.vue?vue&type=style&index=0&id=494af536&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494af536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494af536')) {
      api.createRecord('494af536', component.options)
    } else {
      api.reload('494af536', component.options)
    }
    module.hot.accept("./detail-payin.vue?vue&type=template&id=494af536&scoped=true", function () {
      api.rerender('494af536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/detail-payin.vue"
export default component.exports